import { Check } from "lucide-react";
import { STAGES } from "@/data/demo";
import { cn } from "@/lib/utils";

const Node = ({ status, n }) => {
  if (status === "done") {
    return <div className="relative z-10 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-emerald-500 text-white shadow-sm"><Check size={18} strokeWidth={3} /></div>;
  }
  if (status === "current") {
    return (
      <div className="relative z-10 grid h-9 w-9 shrink-0 place-items-center">
        <span className="absolute inset-0 animate-ping rounded-full bg-amber-400/50" />
        <span className="relative grid h-9 w-9 place-items-center rounded-full bg-gold font-bold text-white ring-4 ring-amber-100">{n}</span>
      </div>
    );
  }
  return <div className="relative z-10 grid h-9 w-9 shrink-0 place-items-center rounded-full border-2 border-dashed border-slate-300 bg-white text-sm font-semibold text-slate-400">{n}</div>;
};

export const CaseJourney = ({ caseData }) => (
  <ol data-testid="case-journey-stepper" className="relative">
    {STAGES.map((s, i) => {
      const status = i < caseData.stage ? "done" : i === caseData.stage ? "current" : "upcoming";
      const last = i === STAGES.length - 1;
      return (
        <li key={s.title} data-testid={`journey-step-${i + 1}`} data-status={status} className="relative flex gap-4 pb-6 last:pb-0">
          {!last && <span className={cn("absolute left-[17px] top-9 bottom-0 w-0.5", i < caseData.stage ? "bg-emerald-400" : "bg-slate-200")} />}
          <Node status={status} n={i + 1} />
          <div className={cn("flex-1 rounded-2xl border p-4 transition-colors",
            status === "current" ? "border-amber-300 bg-amber-50 ring-2 ring-amber-400/30" : status === "done" ? "border-emerald-100 bg-white" : "border-slate-200 bg-slate-50/60")}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <h4 className={cn("font-heading font-semibold", status === "upcoming" ? "text-slate-500" : "text-navy")}>{s.title}</h4>
              {status === "done" && <span className="text-xs font-semibold text-emerald-700">{caseData.dates[i]}</span>}
              {status === "current" && <span className="rounded-full bg-gold px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">Current</span>}
              {status === "upcoming" && <span className="text-xs font-medium text-slate-400">Upcoming</span>}
            </div>
            <p className={cn("mt-1 text-sm", status === "upcoming" ? "text-slate-400" : "text-slate-600")}>{s.desc}</p>
            {s.sub && (
              <div className="mt-3 flex flex-wrap items-center gap-1.5">
                {s.sub.map((x, j) => (
                  <span key={x} className="flex items-center gap-1.5 text-xs text-slate-500">
                    <span className="rounded-md border border-slate-200 bg-white px-2 py-1">{x}</span>
                    {j < s.sub.length - 1 && <span className="text-slate-300">→</span>}
                  </span>
                ))}
              </div>
            )}
          </div>
        </li>
      );
    })}
  </ol>
);
